module.exports = __webpack_public_path__ + "img/audio-off.77eb9bad.svg";